module.exports = __webpack_public_path__ + "img/BI5.7e3978fd.png";